import React from 'react';
import _ from 'lodash';

const AmazTag = ({ data = {}}) => (
  <span
    className="p1 px-2 border-radius-sm nowrap"
    style={{ background: _.get(data, 'style.background'), color: _.get(data, 'style.color') }}
  >
    {_.get(data, 'style.icon')
      ? <span
        className="bg-contain mr-2"
        style={{
          width: '15px',
          height: '15px',
          backgroundImage: `url(${_.get(data, 'style.icon')})`
        }}
      />
      : <span className="mr-1">{_.get(data, 'style.emoji')}</span>}
    <small>
      {data.name} {_.get(data, 'i18n.zh-hk.name')}
    </small>
  </span>
);

export default AmazTag;
